import { buildFormData } from "./payload.helper";

const usersHelper = {
  forCreate: ({ name, email, password, role_id, image , unit_id }) =>
    buildFormData({ name, email, password, role_id, image , unit_id }),
  forUpdate: (id, { name, email, role_id, image , unit_id}) => ({
    id,
    body: buildFormData({ name, email, role_id, image , unit_id}),
  }),
};

 const userProfileHelper = {
    forUpdate: (id, { name, email, image }) => ({
      id,
      body: buildFormData({ name, email, image , type: "profile" }),
    }),
    forPasswordUpdate: (id, { current_password, password }) => ({
      id,
      body: buildFormData({ current_password, password , type: "password" }),
    }),
  };
export default usersHelper;
export { userProfileHelper };
